/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './index.scss';
import { Table, Label } from 'semantic-ui-react';
import formatNumber from 'helpers/formatNumber';
import capitalize from 'utils/capitalize';
import Thumbnail from 'components/common/Thumbnail';
import Tooltip from 'components/common/Tooltip';
import ApprovalsPopupContent from './ApprovalsPopupContent';

const LoanRequestTable = ({ items, activeTab }) => {
  const { push } = useHistory();

  const {
    details: { roles },
  } = useSelector(({ user: { currentUser } }) => currentUser);

  const params = useParams();

  const isSaAdmin = roles.some(role => role.name === 'sa_admin');
  const isSupportAdmin = roles.some(
    role => role.name === 'sa_support_admin',
  );
  const isLoanAdmin = roles.some(role => role.name === 'loan_admin');
  const isLoanOfficer = roles.some(
    role => role.name === 'loan_officer',
  );
  const hasMicroloanPermission =
    isSaAdmin || isSupportAdmin || isLoanAdmin || isLoanOfficer;

  return (
    <>
      <div className="list-loan-requests__items__table">
        <Table basic="very" size="small" textAlign="left">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                className=""
                style={{ paddingLeft: '15px' }}
              >
                Group
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Type
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                <span>Requested amount</span>
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Repayment Days
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                <span>Interest</span>
              </Table.HeaderCell>
              {activeTab === 'approved' && (
                <Table.HeaderCell className="table-data">
                  <span>Outstanding Loan</span>
                </Table.HeaderCell>
              )}
              <Table.HeaderCell className="table-data">
                Loan reason
              </Table.HeaderCell>
              {activeTab === 'approved' || (
                <Table.HeaderCell className="table-data" width="1">
                  Approvals
                </Table.HeaderCell>
              )}
            </Table.Row>
          </Table.Header>

          <Table.Body
            className={`list-loan-requests__items__table__tbody wallet__transactions--table-body ${true &&
              'lg-tbody'}`}
          >
            {items.map(request => {
              return (
                <Table.Row
                  key={request.id}
                  className="table-row cursor"
                >
                  <Table.Cell
                    className="wallet__transactions--originator"
                    onClick={() =>
                      hasMicroloanPermission &&
                      push(
                        `/organizations/${params?.organizationId}/requests/${request?.id}`,
                      )
                    }
                    style={{
                      paddingLeft: '15px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Thumbnail
                      name={request?.group?.name}
                      style={{
                        marginRight: '10px',
                      }}
                    />
                    <div
                      style={{
                        fontSize: '14px',
                      }}
                    >
                      <span
                        style={{
                          fontFamily:
                            '"Helvetica Neue", Helvetica, Arial, sans-serif',
                          fontWeight: 500,
                        }}
                      >
                        {request?.group?.name?.toUpperCase()}
                      </span>
                      <div style={{ fontSize: '14px' }}>
                        <span>
                          {request?.group?.organization?.name}
                        </span>
                      </div>
                    </div>
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {capitalize(request?.type?.replace(/_/g, ' '))}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.amount)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.repayment_days)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.loans_interest)}
                  </Table.Cell>
                  {activeTab === 'approved' && (
                    <Table.Cell className="table-data">
                      {formatNumber(request.loans_balance)}
                    </Table.Cell>
                  )}
                  <Table.Cell className="table-data">
                    {capitalize(request.purpose)}
                  </Table.Cell>
                  {activeTab === 'approved' || (
                    <Table.Cell className="table-data" width="2">
                      <div className="flex flex-between flex-center-vertical">
                        <span className="more-info">
                          <Tooltip
                            id={`approvals-tooltip-${request.id}`}
                            trigger={
                              <Label
                                style={{
                                  backgroundColor: '#FFEBC0',
                                  color: '#000000',
                                  cursor: 'default',
                                }}
                              >
                                {request?.admins_approvals?.reduce(
                                  (acc, curr) => {
                                    if (curr.status === 'accepted') {
                                      return acc + 1;
                                    }
                                    return acc;
                                  },
                                  0,
                                ) || 0}
                                /3 APPROVALS
                              </Label>
                            }
                            content={
                              <ApprovalsPopupContent
                                request={request}
                              />
                            }
                          />
                        </span>
                      </div>
                    </Table.Cell>
                  )}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

LoanRequestTable.defaultProps = {
  items: [],
  activeTab: 'submitted',
};

LoanRequestTable.propTypes = {
  items: PropTypes.array,
  activeTab: PropTypes.string,
};

export default LoanRequestTable;
